import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import styles from './slider-jss'
import {gaEventHit} from '../../service/service_base';
import RadioCard from '../../components/CardPaper/RadioCard';
import { fetchCall } from '../../service/service_base';
import GenericCarousel from './GenericCarousel';

class SliderRadio extends React.Component {

  state = {
    notes: [],
    menuname:null
  }
  componentDidMount() {
    if (!this.props.isSearching) {
      this._load();
    } else {
      if (this.props.section) {
        this.setState(
          {
            notes: []
          }, () => {
            this.setState(
              {
                notes: this.props.section.content
              }
            )
          }
        )
      }
    }
  }

  _load = () => {
    fetchCall("POST", "/synthesis/getcontentpublish", {
      sectionId: this.props.section.sec_id,
      menuId: this.props.idMenuSelected
    }).then(response => {
      let sm = JSON.parse(localStorage.getItem("session_menu"))

        let menu = [];
        if (Array.isArray(sm)) {
          menu = sm.find(x => x.menu_id === this.props.idMenuSelected);
        }
        const menuname = menu;

      this.setState({ notes: response.data , menuname:menuname.menu_name});
    }).catch(err => console.log(err));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSearching && nextProps.section) {
      this.setState({
        notes: nextProps.section.content
      });
    }
  }

  sendEvent=()=>{
    if(this.state.menuname)
      gaEventHit(this.state.menuname,this.props.section.sec_name)
  }

  renderRadioCard = (item, index) => {
    const { isSearching, section } = this.props;
    
    if (item.cont_key) {
      item.cont_imagePath = item.cont_key;
    }
    
    return (
      <RadioCard
        image={isSearching ? item.cont_imagePath : item.cont_key}
        title={item.cont_name}
        description={item.cont_description}
        program={item.cont_program}
        attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
        publish_date={item.publish_date}
        colorTitle={section.sec_color}
        sendEvent={this.sendEvent}
        inCarousel={true}
      />
    );
  }

  render() {
    const { isSearching, section } = this.props;
    const isWhiteBackground = section.sec_color === '';

    return (
      <div id={this.props.sec_name} className="container custom-arrow">
        <Hidden smDown>
          <Grid container spacing={24}>
            {this.state.notes.map((item, key) => {
              if (item.cont_key) {
                item.cont_imagePath = item.cont_key;
              }
              return (
                <Grid item lg={4} md={6} sm={6} xs={12} key={key}>
                  <RadioCard
                    image={isSearching ? item.cont_imagePath : item.cont_key}
                    title={item.cont_name}
                    description={item.cont_description}
                    program={item.cont_program}
                    attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
                    publish_date={item.publish_date}
                    colorTitle={section.sec_color}
                    sendEvent={this.sendEvent}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Hidden>

        <Hidden mdUp>
          <GenericCarousel
            items={this.state.notes}
            renderItem={this.renderRadioCard}
            isWhiteBackground={isWhiteBackground}
          />
        </Hidden>
      </div>
    );
  }
}

SliderRadio.propTypes = {
  classes: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  idMenuSelected: PropTypes.any,
  isSearching: PropTypes.bool,
};

export default withStyles(styles)(SliderRadio);